export default "__VITE_ASSET__n0Y4RhTe__"